import Loading from '../../../Common/Loading';
import { AverageValuePerMonth } from './AverageValuePerMonth';
import { AverageValuePerYear } from './AverageValuePerYear';
import { TransferValuePerMonth } from './TransferValuePerMonth';
import { TransferValuePerYear } from './TransferValuePerYear';
import { useBasicBenefitsChartsDataContext } from './hooks/useBasicBenefitsChartsDataContext';

export const Charts = () => {
    const { isLoading } = useBasicBenefitsChartsDataContext();

    if (isLoading) {
        return (
            <Loading message="Devido ao alto volume de informações, essa operação pode levar alguns instantes." />
        );
    }

    return (
        <>  
            <div className='chats-indicators-side-by-side-dashboards mb-3'>
                <AverageValuePerYear />
                <AverageValuePerMonth />
            </div>
            <div className='chats-indicators-side-by-side-dashboards'>
                <TransferValuePerYear />
                <TransferValuePerMonth />
            </div>
        
        </>
    );
};
